import { ListTodo } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function MyTicketsNavLink({
  compact,
  onNavigate,
  label,
}: {
  compact: boolean
  onNavigate: () => void
  label: string
}) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onNavigate}
      className={compact ? 'cursor-pointer hover:bg-accent' : 'gap-1.5 cursor-pointer'}
      aria-label={label}
    >
      <ListTodo className={compact ? 'h-5 w-5' : 'h-4 w-4'} />
      {!compact && <span className="max-w-[120px] truncate sm:max-w-none">{label}</span>}
    </Button>
  )
}
